import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/shared/config.service';
import { FormDataService } from 'src/app/shared/form-data.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  contentDetail: any;
  showModelLoader:boolean;
  enablePerspective = "";

  constructor(public dialogRef: MatDialogRef<ModalComponent>, private configService: ConfigService, private formDataService: FormDataService,) { 
    this.contentDetail = this.configService.config.Data.contentDetail;    

    this.showModelLoader = false;   

    this.enablePerspective = this.configService.config.Data.EnablePerspective;

    if(this.enablePerspective == null || this.enablePerspective == "")
    {
      this.enablePerspective = "no";
    }

    var perspectiveSides = this.formDataService.perspectiveSides;
    if(perspectiveSides != null && perspectiveSides.length > 0 && this.enablePerspective.toLowerCase() == "yes")
    {
      this.showModelLoader = true;
    }
    
  }

  ngOnInit() {
    
  }

  closeModal() {
    this.dialogRef.close();
  }  

}
